import notFoundStateImage from '@/assets/animation-states/404-asset.avif';
import emptyStateImage from '@/assets/animation-states/empty-asset.avif';
import maintenanceStateImage from '@/assets/animation-states/maintenance-asset.avif';
import loadingStateVideo from '@/assets/animation-states/vh3-loading.webm';

export type PageStateVariant =
  | 'empty'
  | 'reconnecting'
  | 'notFound'
  | 'maintenance'
  | 'error';

interface PageStateConfig {
  title: string;
  topBarTitle?: string;
  description: string;
  footerPrimary?: string;
  footer?: string;
  imageSrc: string;
}

export const PAGE_STATE_CONFIGS: Record<PageStateVariant, PageStateConfig> = {
  empty: {
    title: 'Looks empty...',
    description:
      "There's nothing to display yet. Start by adding\ndata or connecting integrations.",
    imageSrc: emptyStateImage,
  },
  reconnecting: {
    title: 'Reconnecting...',
    topBarTitle: 'Reconnecting',
    description:
      "We're restoring your session and syncing your data.\nThis will only take a moment.",
    footer: 'If nothing happens,\nplease refresh the page.',
    imageSrc: emptyStateImage,
  },
  notFound: {
    title: 'Page not found...',
    description:
      "The page you're looking for doesn't exist\nor may have been moved.",
    imageSrc: notFoundStateImage,
  },
  maintenance: {
    title: 'Maintenance...',
    topBarTitle: 'Maintenance',
    description:
      'VH3 is currently undergoing maintenance\nto improve performance and stability.',
    footerPrimary: "We'll be back shortly.",
    footer: 'Thank you for your patience.',
    imageSrc: maintenanceStateImage,
  },
  error: {
    title: 'Something didn’t load...',
    description:
      'We couldn’t load the data.\nPlease refresh the page and try again.',
    imageSrc: emptyStateImage,
  },
};

export const PAGE_STATE_LOADING_VIDEO_SRC = loadingStateVideo;
export const PAGE_STATE_OVERLAY_VARIANTS: PageStateVariant[] = [
  'reconnecting',
  'maintenance',
];
export const PAGE_STATE_HOME_BUTTON_VARIANTS: PageStateVariant[] = [
  'empty',
  'notFound',
];

export const PAGE_STATE_HEADER_BG =
  'linear-gradient(180deg, #171A1D 5%, rgba(23, 26, 29, 0.60) 100%)';
export const PAGE_STATE_TITLE_GRADIENT =
  'linear(90deg, #8D9395 0%, #FFF 35%, #FFF 65%, #8D9395 100%)';
export const PAGE_STATE_LOGO_SRC =
  'https://cdn.prod.website-files.com/66f62ac0b4dbc96bb348eb73/694811546c1d9a052e5631f8_VH3AI%20-%20Main%20Logo%20-%20Color.png';
